import ChannelsOverview from '../../features/channels/layouts/overview';

export default function ChannelsPage() {
    return <ChannelsOverview />;
}
